import { Notification, Transition } from "@mantine/core";
import type { ToastState } from "@hooks/useToast";
import "./Toast.scss";

interface ToastProps {
    toast: ToastState;
    onClose: () => void;
}

const severityColorMap: Record<string, string> = {
    success: "green",
    error: "red",
    warning: "yellow",
    info: "blue",
};

export const Toast = ({ toast, onClose }: ToastProps) => {
    return (
        <Transition mounted={toast.open} transition="slide-left" duration={300}>
            {(styles) => (
                <div
                    className="custom-toast"
                    style={{
                        ...styles,
                        position: 'fixed',
                        bottom: 24,
                        right: 24,
                        zIndex: 1000,
                    }}
                >
                    <Notification
                        color={severityColorMap[toast.severity] || "blue"}
                        onClose={onClose}
                        className="alert-message"
                        withCloseButton
                    >
                        {toast.message}
                    </Notification>
                </div>
            )}
        </Transition>
    );
};
